var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column mt-16"},[_c('v-icon',{staticClass:"ma-auto",attrs:{"size":"100"}},[_vm._v(" mdi-vector-selection ")]),_c('span',{staticClass:"ma-auto no-select"},[_vm._v(" Wähle einen Text aus ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }